import React, { useState } from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubTitle } from 'components/SubTitle/SubTitle';
import { ThemedTextField } from 'components/ThemedTextField/ThemedTextField';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

import { ExpertSearchDropdownCity } from './edis/ExpertSearchDropdownCity';
import { ExpertSearchDropdownExpert } from './edis/ExpertSearchDropdownExpert';
import { YExpertSearchDialog } from './edis/YExpertSearchDialog';

import './ExpertSearch.sass';

const ExpertSearch = (props) => {
  const [city, setCity] = useState('');
  const [district, setDistrict] = useState('');
  const [error, setError] = useState('');

  const filterCity = (location) => {
    setCity(location.city);
    setDistrict(location.district);
  };

  const formik = useFormik({
    initialValues: { zip: '' },
    validationSchema: YExpertSearchDialog,
  });
  const { headline, tile } = props;
  const { values, handleChange, handleBlur, touched, errors, isValid, resetForm } = formik;

  const onReset = () => {
    resetForm();
    setCity('');
    setDistrict('');
    setError('');
  };
  const isEditor = Utils.isInEditor();

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="ExpertSearch" />;
  }
  return (
    <div className="expert-page">
      <div className="mdl-grid expert-page-content-sites">
        <div
          className={`expert-page-content-search${getTenantId() === TENANT_ID.BAG ? '__bag' : ''}`}>
          {error ? (
            <div className="expert-page-error-message">{error}</div>
          ) : (
            <div className="hidden" />
          )}
          <div className="expert-page-content-search-box">
            <SubTitle text={headline} notFramed />

            <div className="expert-search-dialog__form-field-wrapper">
              <div className="expert-search-dialog__zip-form-wrapper">
                <ThemedTextField
                  fullWidth
                  id="zip"
                  name="zip"
                  label="PLZ *"
                  variant="standard"
                  value={values.zip}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.zip && Boolean(errors.zip)}
                  helperText={touched.zip && errors.zip}
                />
              </div>

              {values.zip && isValid && (
                <ExpertSearchDropdownCity
                  zip={values.zip}
                  tile={tile}
                  backLink={filterCity}
                  errorBackLink={setError}
                />
              )}
            </div>

            {city.length > 0 ? (
              <ExpertSearchDropdownExpert
                zip={values.zip}
                city={city}
                district={district}
                tile={tile}
                errorBackLink={setError}
                onReset={onReset}
              />
            ) : (
              <div className="hidden"> </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ExpertSearch.propTypes = {
  headline: PropTypes.string,
  tile: PropTypes.string,
};

ExpertSearch.defaultProps = {
  headline: 'Angaben zum XXX',
  tile: 'A',
};

MapTo(['e-fix/components/content/expertcontacts'])(ExpertSearch);
